import { useParams } from "react-router";
import { ReservationDetails } from "shared/components";
import { PublicPayerPageShell } from "shared/components/layouts";

export const Reservation = () => {
  const { orderId } = useParams();

  const token = `wbts-reservation${orderId}`.substring(0, 24);
  const ctxHeaders = {
    authorization: `Bearer ${token}`,
    metadata: JSON.stringify({
      type: "RESERVATION",
      entityId: orderId,
    }),
    "wa-type": "reservation",
  };

  return (
    <PublicPayerPageShell
      ctxHeaders={ctxHeaders}
      posthogInstanceId="whereabouts-next-onboarding"
    >
      <ReservationDetails orderId={orderId ?? ""} isPublic={true} maxW="600px" />
    </PublicPayerPageShell>
  );
};
